/* global femcare, Swiper */

femcare.gallery.innovation = {
    init() {
        const innovations = document.querySelectorAll('.innovations');

        if (innovations.length) {
            innovations.forEach(slider => {
                new Swiper(slider.querySelector('.swiper'), {
                    slidesPerView: 'auto',
                    breakpoints: {
                        350: {
                            spaceBetween: 15
                        },
                        1200: {
                            spaceBetween: 30
                        }
                    },
                    mousewheel: {
                        forceToAxis: true
                    }
                });
            });
        }
    }
};
